export default __webpack_public_path__ + "static/media/rooms.4857f1fe.png";